import axios from "axios";

let razorpayScriptPromise;

function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve();
  if (razorpayScriptPromise) return razorpayScriptPromise;

  razorpayScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Unable to load Razorpay SDK."));
    document.body.appendChild(script);
  });

  return razorpayScriptPromise;
}

function authHeaders() {
  const token = localStorage.getItem("user_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function launchBookingPayment({ bookingId, payType = "full" }) {
  const startRes = await axios.post(
    `${process.env.REACT_APP_APP_DOMAIN}/api/payment/start`,
    {
      booking_id: bookingId,
      pay_type: payType,
    },
    { headers: authHeaders() },
  );

  const payload = startRes?.data || {};
  if (!payload?.status) {
    throw new Error(payload?.message || "Unable to start payment.");
  }

  if (payload.checkout_mode === "redirect" && payload.redirect_url) {
    window.location.href = payload.redirect_url;
    return;
  }

  if (payload.gateway !== "razorpay") {
    throw new Error("Unsupported payment gateway mode.");
  }

  await loadRazorpayScript();

  const failRedirect = () => {
    const bookingCode = payload.booking_code || "";
    const orderId = payload.order_id || "";
    window.location.href = `/payment-status?order_id=${encodeURIComponent(orderId)}&booking_code=${encodeURIComponent(bookingCode)}&status=failed`;
  };

  // Padded compact logo (Razorpay logo slot is fixed size).
  const logoUrl = "data:image/png;base64,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";

  const options = {
    key: payload.razorpay_key_id,
    amount: payload.amount,
    currency: payload.currency || "INR",
    name: "Orbi Cabs",
    description: "Booking Payment",
    image: logoUrl,
    order_id: payload.razorpay_order_id,
    handler: async function (response) {
      try {
        const verifyRes = await axios.post(
          payload.verify_url || `${process.env.REACT_APP_APP_DOMAIN}/api/payment/verify`,
          {
            order_id: payload.order_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          },
          { headers: authHeaders() },
        );

        const verifyPayload = verifyRes?.data || {};
        if (verifyPayload?.status && verifyPayload?.redirect_url) {
          window.location.href = verifyPayload.redirect_url;
          return;
        }
        failRedirect();
      } catch (error) {
        failRedirect();
      }
    },
    modal: {
      ondismiss: failRedirect,
    },
    theme: {
      color: "#f8ba05",
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.on("payment.failed", failRedirect);
  rzp.open();
}
